import FeaturesMobile from './FeaturesMobile';

export default FeaturesMobile;
export { FeaturesMobile };
